import { useEffect, useState } from "react";
import api from "../../lib/api";

export const ApiLogs = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/logs").then((r) => setData(r.data)).catch(() => setData({ logs: [], total_est_cost_usd: 0, by_service: {} }));
  }, []);

  if (!data) return <p className="text-sm text-soot">Loading…</p>;

  return (
    <div data-testid="api-logs">
      <h2 className="font-heading text-2xl font-extrabold tracking-tight text-ink">API Usage & Estimated Costs</h2>
      <div className="mt-5 flex flex-wrap gap-4">
        <div className="card-surface px-6 py-4">
          <p className="text-xs font-bold uppercase tracking-wider text-soot">Total estimated</p>
          <p data-testid="logs-total-cost" className="font-heading text-3xl font-extrabold text-pine">${data.total_est_cost_usd.toFixed(4)}</p>
        </div>
        {Object.entries(data.by_service).map(([svc, cost]) => (
          <div key={svc} className="card-surface px-6 py-4">
            <p className="text-xs font-bold uppercase tracking-wider text-soot">{svc}</p>
            <p className="font-heading text-3xl font-extrabold text-ink">${cost.toFixed(4)}</p>
          </div>
        ))}
      </div>
      <p className="mt-3 text-xs text-soot">Costs are rough estimates for monitoring only — check provider consoles for actual billing.</p>
      <div className="card-surface mt-6 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="border-b border-pine-soft bg-pine-light/40 text-xs uppercase tracking-wider text-soot">
                <th className="px-5 py-3.5 font-bold">When</th>
                <th className="px-5 py-3.5 font-bold">Service</th>
                <th className="px-5 py-3.5 font-bold">Endpoint / model</th>
                <th className="px-5 py-3.5 font-bold">Est. cost</th>
                <th className="hidden px-5 py-3.5 font-bold md:table-cell">Note</th>
              </tr>
            </thead>
            <tbody>
              {data.logs.length === 0 && (
                <tr><td colSpan={5} className="px-5 py-8 text-center text-soot">No API calls logged yet.</td></tr>
              )}
              {data.logs.map((l, i) => (
                <tr key={i} className="border-b border-pine-soft/60 last:border-0">
                  <td className="whitespace-nowrap px-5 py-3 text-soot">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-5 py-3 font-semibold text-ink">{l.service}</td>
                  <td className="px-5 py-3 text-soot">{l.endpoint}</td>
                  <td className="px-5 py-3 text-ink">${(l.est_cost_usd || 0).toFixed(4)}</td>
                  <td className="hidden px-5 py-3 text-soot md:table-cell">{l.note || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
